import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedSummary: null,
  selectedSaleSummary: null,
  selectedIntransitSummary: null
};

const summarySlice = createSlice({
  name: 'summaryTable',
  initialState,
  reducers: {
    setSelectedSummary: (state, action) => {
      state.selectedSummary = action.payload;
    },
    setSelectedSaleSummary: (state, action) => {
      state.selectedSaleSummary = action.payload;
    },
    setSelectedIntransitSummary: (state, action) => {
      state.selectedIntransitSummary = action.payload;
    },
  }
});

export const {
  setSelectedSummary, 
  setSelectedSaleSummary,
  setSelectedIntransitSummary
} = summarySlice.actions;

// Selectors

export const selectSelectedCell = (state) => state.summaryTable.selectedSummary;


export default summarySlice.reducer;